import React from 'react'
import { StarRating } from 'src/components/global/StarRating'
import { ISolutionReviewFragment } from 'src/graphql/generated/hooks'

interface Props {
  reviews: ISolutionReviewFragment[]
}

export const SolutionHeaderReviewStar: React.FC<Props> = ({ reviews }) => {
  let liststar = 0
  reviews.forEach((item) => {
    liststar += item.attributes?.rating || 0
  })
  liststar = reviews.length === 0 ? 0 : liststar / reviews.length
  const listreviewer = reviews.length
  let reviewLabel = ''
  if (listreviewer === 0) {
    reviewLabel = '(No Reviews)'
  } else if (listreviewer === 1) {
    reviewLabel = '(1 Review)'
  } else {
    reviewLabel = `(${listreviewer} Reviews)`
  }

  return (
    <div className="flex flex-col md:flex-row mt-[5px]">
      <StarRating value={liststar} type={0} readOnly={true} />
      <div className="text-[0.8125rem] text-center md:text-left text-textdark font-primary md:ml-[10px]">
        {reviewLabel}
      </div>
    </div>
  )
}
